var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickLogo = function SvgTickLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.692 22.15c1.318.068 2.19-1.35 1.534-2.493L12.888 5.136l-.004-.007-.003-.008C10.959 1.508 9.039.605 7.684.509c-1.4-.099-2.397.638-2.543.732l-.001.001c-.422.27-.911.791-1.421 1.47a23 23 0 0 0-1.433 2.201 40 40 0 0 0-1.47 2.782l-.021.044-.005.012v.002H.787l-.007.015-.008.016-.107.219a1.9 1.9 0 0 0 .129 1.789l.015.022.014.018.012.019c.71 1.103 2.388 1.122 3.09.15l1.57-2.534c1.043-1.713 3.535-1.704 4.564.02l8.277 13.853c.25.418.667.702 1.139.786l.206.023z"
  })));
};
export default SvgTickLogo;